<template>
  <div class="contant-wrap">
    <div class="header">
      <h4 class="common-title">挂号费用设置</h4>
    </div>
    <el-button type="primary" class="button" @click="addInspect">新增</el-button>
    <el-table
      :data="tableData"
      :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}"
      style="width: 100%; margin-top: 30px; ">
      <el-table-column
        prop="registerName"
        label="挂号项名称"
        width="">
      </el-table-column>
      <el-table-column
        prop="registerCost"
        label="成本价"
        width="">
        <template slot-scope="scope">
          ￥{{ scope.row.registerCost }}
        </template>
      </el-table-column>
      <el-table-column
        prop="registerPrice"
        label="销售价"
        width="">
        <template slot-scope="scope">
          ￥{{ scope.row.registerPrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="操作"
        width="180">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="updateInspect(scope.row)">编辑</el-button>
            <el-popover
              placement="top"
              width="160"
              v-model="scope.row.visible">
              <p>确定删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="scope.row.visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="() => { deleteInspect(scope.row.registerTypeId);scope.row.visible = false }">确定</el-button>
              </div>
              <el-button type="text" style="margin-left: 10px;" slot="reference">删除</el-button>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="tableData.length > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.currentPage"
        :page-sizes="pageSizes"
        :page-size.sync="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      center
      :before-close="handleClose">
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="挂号项名称：" prop="registerName">
            <el-input v-model="ruleForm.registerName" maxlength="10"></el-input>
          </el-form-item>

          <el-form-item label="成本价：" prop="registerCost">
            <el-input v-model="ruleForm.registerCost"></el-input>
          </el-form-item>
          <el-form-item label="销售价：" prop="registerPrice">
            <el-input v-model="ruleForm.registerPrice"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pageSizes } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize.js';
import { checkAmt } from '@/utils/validate/elementMethod';

export default {
  name: 'inspect',
  mixins: [ pageSize ],
  data() {
    return {
      dialogTitle: '新增检查治疗项',
      dialogVisible: false,
      pageSizes: pageSizes,
      query: {
        currentPage: 1, // 页码 从1开始
        pageSize: pageSize, // 每页数据条数
      },
      tableData: [],
      ruleForm: {
        registerName: '',
        registerCost: '',
        registerPrice: '',
      },
      rules: {
        registerName: [
          { required: true, message: '请输入检查治疗项名称', trigger: 'blur' },
        ],
        registerCost: [
          { required: true, validator: checkAmt, trigger: 'blur' },
        ],
        registerPrice: [
          { required: true, validator: checkAmt, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    // 获取列表信息
    getTableData(type) {
      if(type === 1) this.query.currentPage = 1;
      this.$api.clinicManagement.pageRegisterType(this.query).then(res => {
        console.log(res);
        this.tableData = res.hospitalRegisterTypes || [];
        this.total = res.totalSize || 0;
      })
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(value) {
      this.getTableData();
    },
    // 添加挂号费用
    addInspect() {
      this.dialogTitle = '新增挂号项';
      this.dialogVisible = true;
      this.ruleForm = {
        registerName: '',
        registerCost: '',
        registerPrice: '',
      };
    },
    // 编辑挂号费用
    updateInspect(rows) {
      this.dialogTitle = '编辑挂号项';
      this.dialogVisible = true;
      this.ruleForm.registerName = rows.registerName;
      this.ruleForm.registerCost = rows.registerCost;
      this.ruleForm.registerPrice = rows.registerPrice;
      this.ruleForm.registerTypeId = rows.registerTypeId;
    },
    // 关闭弹窗之前重置表单
    handleClose() {
      this.ruleForm = {
        registerName: '',
        registerCost: '',
        registerPrice: '',
      };
      this.dialogVisible = false;
    },
    // 删除挂号项
    deleteInspect(registerTypeId) {
      this.$api.clinicManagement.deleteRegisterType({
        registerTypeId: registerTypeId,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功！',
        });
        this.getTableData(1);
      });
    },
    // 添加挂号项
    insertRegisterType() {
      this.$api.clinicManagement.insertRegisterType({
        ...this.ruleForm,
      }).then(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'success',
          message: '添加成功！',
        });
        this.getTableData(1);
      });
    },
    // 修改挂号项
    updateRegisterType() {
      this.$api.clinicManagement.updateRegisterType({
        ...this.ruleForm,
      }).then(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'success',
          message: '修改成功！',
        });
        this.getTableData(1);
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle === '新增挂号项') {
            this.insertRegisterType();
          } else {
            this.updateRegisterType();
          }
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.getTableData(1);
  },
}
</script>
<style lang="scss" scoped>
.contant-wrap {
  box-sizing: border-box;
  min-height: 100%;
}
.button {
  margin-top: 40px;
}
</style>
